import * as echarts from 'echarts'
import { addListener } from 'resize-detector'
const moment = require('moment')
moment.locale('ru')

/* eslint-disable */
export default {
  methods: {
    createChartLine(blockId, chartData, lineChartOptions) {
      var myChart = echarts.init(document.getElementById(blockId))

      let option = this.createOptionsForLine(chartData, lineChartOptions)
      myChart.setOption(option)

      let zr = myChart.getZr()
      zr.on('click', e => {
        if (e.target == undefined) {
          this.destroyPopup()
        }
      })

      myChart.on('click', 'series', e => {

        let parent = null
        if (document.body.clientWidth > 768) {
          // parent = e.event.event.path[1]
          parent = document.getElementById(blockId)
        } else {
          parent = document.body
        }
        e.dataIndex = e.value[2] // дата индекс работает не правильно т.к. возвращает индекс из серии, а не из всех данных
        let popup = this.createPopup(e, blockId)
        parent.appendChild(popup)
        this.$emit('changeStyleButtonGoChild', {dataIndex: e.dataIndex, blockId: blockId})
      })

      addListener(document.getElementById(blockId), () => {
        myChart.resize()
      })
    },

    createOptionsForLine (chartData, lineChartOptions) {
      let yValueColumn = chartData.y_axis.value_column
      let xValueColumn = chartData.x_axis.value_column
      let groupColumn = chartData.group_column
      let _option = {
        color: this.createLineColors(chartData),
        title: {
          text: chartData.title,
          show: false
        },
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return params.seriesName + '<br>' + params.marker + params.data[1] + '<br>' + moment(params.data[0], ['YYYY-MM-DD HH:mm:ss', 'MM/DD/YY']).format('DD.MM.YYYY')
          }
        },
        legend: {
          type: 'scroll',
          data: chartData.groups.map(elem => {
            return {
              name: elem.title,
              icon: 'circle'
            }
          }),
          padding: [0, 30],
          // textStyle: {
          //   padding: [3, 3, 0, 0],
          // }
        },
        grid: {
          right: '30px',
          left: '45px',
          bottom: '30px',
          top: '30px',
          containLabel: true
        },
        xAxis: {
          type: 'time',
          boundaryGap: false,
          name: chartData.x_axis.title || '',
          nameGap: 40,
          axisLabel: {
            textStyle: {
              color: '#383838'
            },
            formatter: function (value, index) {
              // var date = new Date(value);
              // var texts = date.getDate() + '.' + (date.getMonth() + 1) + '\n' + date.getFullYear();
              // return texts;
              return moment(value).format('DD.MM YYYY').replace(' ', '\n')
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#9ba9b7'
            }
          },
          nameLocation: 'center',
          nameTextStyle: {
            fontWeight: 'bold',
            color: '#474A51'
          },
          xAxisLabel: {
            inside: true
          },
        },
        yAxis: {
          type: 'value',
          name: chartData.y_axis.title,
          nameGap: 70,
          axisLabel: {
            textStyle: {
              color: '#383838'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#9ba9b7'
            }
          },
          nameLocation: 'center',
          nameTextStyle: {
            fontWeight: 'bold',
            color: '#474A51'
          }
        },
        series: this.createSeries(chartData.data, chartData.groups, xValueColumn, yValueColumn, groupColumn)
      }

      _option = this.selectZoomLineChart(_option, lineChartOptions)

      return _option
    },

    createSeries (data, groups, xValueColumn, yValueColumn, groupColumn) {
      // console.log(data)
      let _series = []
      for (let i = 0; i < groups.length; i++) { // create series
        _series.push({
          name: groups[i].title,
          value: groups[i].value,
          type: 'line',
          smooth: true,
          lineStyle: {
            color: groups[i].color,
            width: 2
          },
          itemStyle: {
            borderWidth: 4,
            borderColor: groups[i].color
          },
          data: [
          ]
        })
      }

      for (let i = 0; i < data.length; i++) { // add data to series
        for (let j = 0; j < _series.length; j++) {
          if (_series[j].value === data[i][groupColumn]) {
            // console.log(data[i])
            _series[j].data.push([
                moment(data[i][xValueColumn], ['YYYY-MM-DD HH:mm:ss', 'MM/DD/YY']).format('YYYY-MM-DDTHH:mm:ss'),
                Number(data[i][yValueColumn]),
                i
              ]
            )
          }
        }
      }

      // console.log(_series)
      return _series
    },

    createLineColors (chartData) {
      if (chartData.groups.length && 'color' in chartData.groups[0]) {
        return chartData.groups.map(function (item) {
          return item.color
        })
      } else {
        return ['#00c0ef', '#3c8dbc', '#f66955', '#f39c11', '#00a65a']
      }
    },

    selectZoomLineChart (option, lineChartOptions) {
      if (lineChartOptions === undefined || lineChartOptions.enableZoom) {
        option.dataZoom = [
          {
            show: true,
            disable: true,
            type: 'inside',
            filterMode: 'none',
            xAxisIndex: [0],
            start: 0,
            end: 100
          },
          {
            show: true,
            disable: true,
            type: 'inside',
            filterMode: 'none',
            yAxisIndex: [0],
            start: 0,
            end: 100
          }
        ]
      }
      return option
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/chartLineMix.js